import { render, staticRenderFns } from "./DeleteCompleteModal.vue?vue&type=template&id=4dd1fae8&"
import script from "./DeleteCompleteModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteCompleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports